module.exports = __webpack_public_path__ + "img/image9@2x.edfc7b90.png";